import cx from "classnames";
import {
  IonContent,
  IonLabel,
  IonPage,
  IonSkeletonText,
  useIonRouter,
} from "@ionic/react";

import s from "./WebReferralLanding.module.scss";
import { CheckmarkCircleIcon } from "../../assets/icons";
import brandLogo from "../../../Common/assets/logo/wl-woodmark-logo-rev.svg";
import WLSubscriptionPlanCard from "../../components/WLSubscriptionPlanCard/WLSubscriptionPlanCard";
import { useGetReferralEntries, useSubscriptionsProvider } from "./provider";
import useWebReferralStore from "./store";
import { shallow } from "zustand/shallow";
import { ViewWLSubscriptionsTiers } from "../../../Common/models/subscriptions";
import { useEffect } from "react";

export const WebReferralLanding = () => {
  const router = useIonRouter();
  useSubscriptionsProvider();
  useGetReferralEntries();

  const [subscriptionList, referredBonusEntries] = useWebReferralStore(
    (state) => [state.subscriptionList, state.referredBonusEntries],
    shallow
  );

  const referrerName =
    new URLSearchParams(window.location.search).get("referrerName") || "";

  const navigateWithParams = (newPath: string) => {
    const currentParams = new URLSearchParams(window.location.search);

    const newUrl = `${newPath}?${currentParams.toString()}`;
    router.push(newUrl, "forward");
  };

  const handleSelectSubscription = (subscription: ViewWLSubscriptionsTiers) => {
    navigateWithParams(`/join/${subscription.name.toLowerCase()}`);
  };

  const referralPromoDetails = `Nice one! You've unlocked ${referredBonusEntries?.referedBonusEntries.promoText} and a ${referredBonusEntries?.twoWayBonusEntries.promoText} just for joining through your mate’s referral. Welcome to Winners Locker!`;

  return (
    <IonPage className={s.page}>
      <IonContent className={s.content} fullscreen>
        <div className={s.mobileLogoContainer}>
          <img className={s.logo} src={brandLogo} alt="" loading="eager" decoding="async" />
        </div>

        <div className={s.body}>
          <div className={s.innerContainer}>
            <img className={s.logo} src={brandLogo} alt="" loading="eager" decoding="async" />

            <div className={s.mainDetails}>
              {referredBonusEntries !== undefined && (
                <div className={s.referralPromoSection}>
                  <div>
                    <div className={s.referralPromoSectionTitle}>
                      <CheckmarkCircleIcon className={s.icon} />
                      <IonLabel className="win-sub medium gilroy success">
                        Refer-a-mate Bonus Applied!
                      </IonLabel>
                    </div>
                    <IonLabel className="win-sub medium gilroy ion-text-start">
                      {referralPromoDetails}
                    </IonLabel>
                  </div>
                </div>
              )}

              <div className={s.header}>
                <IonLabel
                  className={cx(
                    s.headerTitle,
                    "win-header-2 medium winnersans primary ion-text-center"
                  )}
                >
                  You've Been Referred to Winners Locker! 🎉
                </IonLabel>
                <IonLabel className="win-sub medium gilroy blue300">
                  Thanks to <b>{referrerName}</b>, you're about to unlock
                  exclusive perks!
                </IonLabel>
                <IonLabel className="win-sub medium gilroy blue300">
                  🏆 Winners Locker is{" "}
                  <b>Australia’s #1 loyalty rewards club</b>, trusted by
                  thousands of members who win big every day. Your referral
                  means you're already ahead—score instant bonuses when you sign
                  up today!
                </IonLabel>
                <a
                  className={cx(
                    s.discoverLink,
                    "win-small regular gilroy primary-500"
                  )}
                  href="https://winnerslocker.com.au/"
                  target="_blank"
                >
                  👉 Click here to discover Winners Locker
                </a>
                <IonLabel className="win-sub medium gilroy blue300">
                  Then, simply <b>choose the subscription</b> that suits you
                  best below and start winning! 💰🎊
                </IonLabel>
              </div>

              {/* <div className={s.header}>
                <IonLabel
                  className={cx(
                    s.headerTitle,
                    "wl-h2-winnersans primary ion-text-center"
                  )}
                >
                  Select your Package
                </IonLabel>
                <IonLabel className="wl-body-3-gilroy-regular ion-text-center">
                  Choose between Starter, Pro, or MVP membership to be
                  automatically entered in every giveaway
                </IonLabel>
              </div> */}

              <div className={s.subscriptionList}>
                {subscriptionList !== undefined ? (
                  <>
                    {subscriptionList.map((subscription) => (
                      <WLSubscriptionPlanCard
                        key={subscription.docId}
                        onSelect={handleSelectSubscription}
                        subscription={subscription}
                      />
                    ))}
                  </>
                ) : (
                  <>
                    <IonSkeletonText className={s.subscriptionSkeleton} />
                    <IonSkeletonText className={s.subscriptionSkeleton} />
                    <IonSkeletonText className={s.subscriptionSkeleton} />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};
